import * as Yup from 'yup';

// ----------------------------------------------------------------------

export const HostgatorFormSchema = Yup.object().shape({
  storeUrl: Yup.string().required('Preenchimento Obrigatório'),
  appKey: Yup.string().required('Preenchimento Obrigatório'),
  storeIntegrationId : Yup.string().required('Preenchimento Obrigatório'),

});

export type THostgatorConfigFormSchema = Yup.InferType<typeof HostgatorFormSchema>;

export const hostgatorConfigFormSchemaDefaultValues: THostgatorConfigFormSchema = {
  storeUrl: '',
  appKey: '',
  storeIntegrationId: '',

};
